import { useContext, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import PropTypes from 'prop-types'

// Context
import { UserContext } from '../../context/UserContext'
import { useOnClickOutside } from 'usehooks-ts'

// Internal components
import Svg from '../Svg/Svg'
import Flag from '@/components/Flag/Flag'

export const linkIsActive = (path, urls) => {
  const validate = Array.isArray(urls) ? urls.some((url) => path.includes(url)) : path === urls
  return validate ? 'is-active' : ''
}

const MainMenu = (props) => {
  const router = useRouter()
  const userContext = useContext(UserContext)

  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )
  const createMarkup = (copy) => ({ __html: copy })
  const [showLangSwitch, setShowLangSwitch] = useState(false)
  const ref = useRef(null)
  useOnClickOutside(ref, () => setShowLangSwitch(false))

  return (
    <div className="MainMenu">
      <div className="MainMenu-inner">
        <div className="MainMenu-wrapper">
          <div className="MainMenu-container">
            <ul className={`MainMenu-list ${userContext?.loadedSession ? 'is-enabled' : ''}`}>
              <li className={`MainMenu-item MainMenu-item--home ${linkIsActive(router.asPath, '/')}`}>
                <Link href="/">
                  <a className="MainMenu-link">
                    <Svg id={'icon-home'} modifiers={['MainMenu-icon']} />
                    <span className="MainMenu-label" dangerouslySetInnerHTML={createMarkup(t('MAINMENU__BTN_HOME'))} />
                  </a>
                </Link>
              </li>

              {userContext?.loggedIn && (
                <li className={`MainMenu-item MainMenu-item--calendar ${linkIsActive(router.asPath, '/calendar')}`}>
                  <Link href="/calendar">
                    <a className="MainMenu-link">
                      <Svg id={'icon-calendar'} modifiers={['MainMenu-icon']} />
                      <span
                        className="MainMenu-label"
                        dangerouslySetInnerHTML={createMarkup(t('MAINMENU__BTN_CALENDAR'))}
                      />
                    </a>
                  </Link>
                </li>
              )}

              <li
                className={`MainMenu-item MainMenu-item--overview ${linkIsActive(router.asPath, [
                  '/overview/',
                  '/exercise/',
                  '/training/',
                  '/program/'
                ])}`}
              >
                <Link href="/overview/trainings">
                  <a className="MainMenu-link">
                    <Svg id={'icon-football'} modifiers={['MainMenu-icon']} />
                    <span
                      className="MainMenu-label"
                      dangerouslySetInnerHTML={createMarkup(t('MAINMENU__BTN_TRAININGS'))}
                    />
                  </a>
                </Link>
              </li>

              <li
                className={`MainMenu-item MainMenu-item--knowledgebase ${linkIsActive(router.asPath, ['/infopage/'])}`}
              >
                <Link href="/infopage/informatie">
                  <a className="MainMenu-link">
                    <Svg id={'icon-tips'} modifiers={['MainMenu-icon']} />
                    <span
                      className="MainMenu-label"
                      dangerouslySetInnerHTML={createMarkup(t('MAINMENU__BTN_KNOWLEDGEBASE'))}
                    />
                  </a>
                </Link>
              </li>

              {userContext?.loggedIn && userContext?.userSession?.team && (
                <li
                  className={`MainMenu-item MainMenu-item--divider ${linkIsActive(router.asPath, ['/profile/team'])}`}
                >
                  <Link href="/profile/team">
                    <a className="MainMenu-link">
                      <Svg id={'icon-team'} modifiers={['MainMenu-icon']} />
                      <span className="MainMenu-label">{userContext.userSession.team.shortTeamName}</span>
                    </a>
                  </Link>
                </li>
              )}

              {process.env.NEXT_PUBLIC_ENABLE_LANGSWITCH === 'true' && (
                <div className="MainMenu-langswitch-container">
                  <li className={`MainMenu-item`} onClick={() => setShowLangSwitch((s) => !s)}>
                    <div className="MainMenu-link">
                      <span className="MainMenu-label">
                        <Flag locale={router.locale} />
                        {router.locale}
                      </span>
                    </div>
                  </li>

                  <div
                    ref={ref}
                    className="MainMenu-langswitch-dropdown"
                    style={{ display: showLangSwitch ? 'block' : 'none' }}
                  >
                    {router.locales.map(
                      (locale) =>
                        locale !== router.locale && (
                          <li className={`MainMenu-item`}>
                            <Link href={`/`} locale={locale} onClick={() => setShowLangSwitch(false)}>
                              <a className="MainMenu-link">
                                <span className="MainMenu-label">
                                  <Flag locale={locale} />
                                  {locale}
                                </span>
                              </a>
                            </Link>
                          </li>
                        )
                    )}
                  </div>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

MainMenu.propTypes = {
  name: PropTypes.string
}

export default MainMenu
